export type SettingsSwitchProps = {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  /** Accessible name for the switch. */
  label: string;
  id?: string;
  /** Tooltip / aria-description, e.g. "Binnenkort beschikbaar" for placeholders. */
  title?: string;
};

/**
 * Token-driven toggle switch. Thumb slides via transform only (brand motion
 * rule — no width/height transition); ease-out, neutralised by reduced-motion.
 * 44px touch-target wrapper. role="switch" + aria-checked.
 */
export function SettingsSwitch({
  checked,
  onChange,
  disabled = false,
  label,
  id,
  title,
}: SettingsSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      id={id}
      aria-checked={checked}
      aria-label={label}
      title={title}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={[
        "relative inline-flex h-[27px] w-[46px] flex-none items-center rounded-full border",
        "transition-colors duration-200 ease-out",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2",
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
        checked
          ? "border-[var(--accent)] bg-[var(--accent)]"
          : "border-[var(--border-strong)] bg-[var(--panel-soft)]",
      ].join(" ")}
    >
      <span
        aria-hidden="true"
        className={[
          "absolute left-[2px] h-[21px] w-[21px] rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,.25)]",
          "transition-transform duration-200 ease-out",
          checked ? "translate-x-[19px]" : "translate-x-0",
        ].join(" ")}
      />
    </button>
  );
}
